import { module } from 'stereomodularjs'

import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, EffectCreative } from 'swiper/modules';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Scrollbar, A11y, EffectCreative]);

export default class extends module {
    constructor(m) {
        super(m)
    }

    init() {
        this.params = {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            grabCursor: true,
            touchEventsTarget: 'container',

            // If we need pagination
            pagination: {
                el: this.el.querySelector('.swiper-pagination'),
                clickable: true,
            },

            // Navigation arrows
            navigation: {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            },

            // And if we need scrollbar
            scrollbar: {
                el: this.el.querySelector('.swiper-scrollbar'),
                draggable: true,
            },

            // a11y
            a11y: {
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
            },
        }

        this.typeSlider = this.el.dataset.type

        if (this.typeSlider == 'card') {
            this.params.navigation = {
                nextEl: this.el.querySelector('.swiper-button-next'),
                prevEl: this.el.querySelector('.swiper-button-prev'),
            }
            this.params.effect = 'creative'
            this.params.creativeEffect = {
                prev: {
                    perspective: true,
                    translate: ['-20%', 0, -400],
                },
                next: {
                    perspective: true,
                    translate: ['102%', 0, 0],
                },
                limitProgress: 2,
            }
        }

        if (this.typeSlider == 'articles') {
            const container = this.el.closest('.js-articles-wrapper');

            if (container) {
                this.params.navigation = {
                    nextEl: container.querySelector('.js-articles-next'),
                    prevEl: container.querySelector('.js-articles-prev'),
                };
            }
        }

        if (this.typeSlider == 'person') {
            this.params.navigation = {
                nextEl: this.el.querySelector('.js-person-next'),
                prevEl: this.el.querySelector('.js-person-prev'),
            };
        }

        this.slider = new Swiper(this.el, this.params)
    }

    destroy() {
        if (this.slider) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}